import React from 'react';
import { DropdownField } from 'components/forms';
import { H1, P } from 'components/text';
import { useBeneficialOwner } from 'lib/beneficial-owner-provider';
import { HelpSection } from 'pages/Start';

const CountryForm = () => {
  const owner = useBeneficialOwner();

  let countries = [];
  if (owner.metadata) {
    countries =
      owner.metadata.individual.children.address.children.country.choices;
    countries = countries.map((c) => ({
      value: c.value,
      label: c.display_name,
    }));
  }

  return (
    <>
      <H1>Beneficial Owner</H1>
      <P>U.S Government regulations require us to know more about you.</P>
      <HelpSection>
        <P>
          <strong>Information required:</strong>
        </P>
        <ul>
          <li>Full legal name and address</li>
          <li>Government identification</li>
          <li>Selfie verification</li>
          <li>Social security number (for US residents)</li>
        </ul>
      </HelpSection>
      <DropdownField
        name={`individual.address.country`}
        label="Country of residence"
        required
        options={countries}
      />
    </>
  );
};

export default CountryForm;
